"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetViableDragPositions = void 0;
var react_1 = require("react");
var ControlledTreeEnvironment_1 = require("./ControlledTreeEnvironment");
var useCanDropAt_1 = require("./useCanDropAt");
var useGetViableDragPositions = function () {
    var environment = (0, ControlledTreeEnvironment_1.useTreeEnvironment)();
    var canDropAt = (0, useCanDropAt_1.useCanDropAt)();
    return (0, react_1.useCallback)(function (treeId, draggingItems) {
        var linearItems = environment.linearItems[treeId];
        return linearItems
            .map(function (_a) {
            var item = _a.item;
            return ({
                targetType: 'item',
                targetItem: item,
                treeId: treeId,
            });
        })
            .filter(function (position) { return canDropAt(position, draggingItems); });
    }, [canDropAt, environment.linearItems]);
};
exports.useGetViableDragPositions = useGetViableDragPositions;
